<template>
  <div />
</template>

<script>
import BasePage from "@/components/pages/BasePage";
import Vue from "vue";

export default {
  name: "BaseMembres",
  extends: BasePage,
  data() {
    return {
      patternName: "",
      pattern: {
        className: "search.CSearchPattern",
        maxResults: Math.min(Math.round(window.innerWidth / 400) * Math.round(window.innerHeight / 130), 20)
      },
      scrollPosition: 0,
      alertName: ""
    };
  },

  created: function() {
    this.initPattern();
  },

  methods: {
    baseInitPattern: function() {
      this.pattern.pageNumber = "0";
      this.pattern.maxResults = Math.round(window.innerWidth / 400) * Math.round(window.innerHeight / 130);
      this.pattern.className = "search.CSearchPattern";
    },

    init: async function() {
      await this.$refs.liste.init();
      this.$store.commit("setLastSearch", this.$refs.liste.scrollableList);
    }
  },

  beforeRouteLeave: function(_to, _from, next) {
    if (this.$refs.liste) {
      this.scrollPosition = this.$refs.liste.$refs.listContainer.scrollTop;
      next();
    }
  },

  /*
  if (this.unit == null) {
        await Vue.nextTick();
        this.$el.scroll(0, this.scrollY);
      } else {
        this.scrollY = this.$el.scrollTop;
        this.$el.scroll(0, 0);
        this.unit.updateDisplayStatus();
        this.$router.push({ name: "app-Lists", hash: "#edit" });
      }
  */

  beforeRouteEnter: function(_to, _from, next) {
    next(async vm => {
      if (vm.$refs.liste) {
        vm.$store.commit("setLastSearch", vm.$refs.liste.scrollableList);

        console.log(vm.$refs.liste.$refs.listContainer.scrollTop);
        if (vm.$store.state.needsReload) {
          vm.$store.state.needsReload = false;
          vm.init();
        }

        await Vue.nextTick();
        vm.$refs.liste.$refs.listContainer.scroll(0, vm.scrollPosition);
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
